import Message from 'shared_components/message';
import { axiosLabAPI, axiosReportAPI } from 'services/axios';
import { API_GET_METHOD, API_POST_METHOD } from 'global_config/constant-global';
import { showMessage } from 'services/settings/message';

export async function fetchXMLNames() {
	let xmlNames = [];

	try{
		const content = {
			method: API_GET_METHOD,
			url: `labreport_api/templatelist.php`,
		}

		const response = await axiosReportAPI(content);
		const { data } = response;

		xmlNames = data;
	}
	catch(e) {
		showMessage(e);
	}

	return xmlNames;
}

export async function deleteXML(payload) {
	let response = null;

	try{
		const content = {
			method: API_POST_METHOD,
			url: `labreport_api/delete.php`,
			data: payload
		}

		response = await axiosReportAPI(content);
	}
	catch(error) {
		response = error.response;
	}

	return response;
}

export async function fetchSections() {
	let sectionItems = [];

	try {
		const response = await axiosLabAPI({
			method: API_GET_METHOD,
			url: `listofvalues/section`,
		});

		const { data } = response;
		sectionItems = data;
	} catch (e) {
		showMessage(e);
	}

	return sectionItems;
}

export async function fetchModuleReports(moduleName) {
	let sectionItems = [];

	try {
		const response = await axiosLabAPI({
			method: API_GET_METHOD,
			url: `reports/jrtemplates/labheroanalysisreports/${moduleName}/`,
		});

		const { data } = response;
		sectionItems = data;
	} catch (e) {
		showMessage(e);
	}

	return sectionItems;
}

export async function fetchReportParameters(reportParam) {
	let sectionItems = [];

	try {
		const response = await axiosLabAPI({
			method: API_GET_METHOD,
			url: `reports/jrformparam/labheroanalysisreports/${reportParam}/`,
		});

		const { data } = response;
		sectionItems = data;
	} catch (e) {
		showMessage(e);
	}

	return sectionItems;
}

export async function generateDataAnalysisReport(moduleName, payload) {
	try {
		const content = {
			method: API_POST_METHOD,
			url: `reports/jrprintform/labheroanalysisreports/${moduleName}/RequestList.jrxml`,
			data: payload
		}

		const response = await axiosLabAPI(content);
		const { data } = await response;

		return data || [];
	}
	catch (e) {
		showMessage(e);
		return false;
	}
}
// export async function printDataAnalysisReport(moduleName, payload) {
//     try {
//         const content = {
//             method: 'POST', // Assuming API_POST_METHOD is 'POST'
//             url: `/reports/jrdirectprint3/labheroanalysisreports/${moduleName}/RequestList.jrxml`,
//             data: payload
//         };

//         const response = await axiosLabAPI(content);
//         const { data } = response;

//         return data;
//     } catch (error) {
// 		if (error.response && error.response.status === 400) {
// 			// Handle 400 status code error
// 			const errorMessage = error.response.data && error.response.data.error;

// 			// Display the error message using Ant Design Message.error
// 			Message.error(errorMessage || 'Bad Request');
// 		} else {
// 			// Handle other errors
// 			Message.error('An error occurred');
// 		}

// 		return false;
// 	}
// }

export async function printDataAnalysisReport(moduleName, payload) {
	try {
		const content = {
            method: 'POST', // Assuming API_POST_METHOD is 'POST'
            url: `/reports/jrdirectprint3/labheroanalysisreports/${moduleName}/RequestList.jrxml`,
            data: payload
        };

		const response = await axiosLabAPI(content);

		return response;
	} catch (e) {
		showMessage(e);
		return false;
	}
}